/**
 * Klaviyo Public API Utility
 * 公共 Klaviyo API 工具，供各活动页订阅模块复用
 * 使用前需先调用 window.klaviyoApi.init(companyId, listId)
 */
(function () {
  var REVISION = '2024-10-15';

  var _companyId = '';
  var _listId = '';

  function klaviyoHeaders() {
    var h = new Headers();
    h.append('revision', REVISION);
    h.append('Content-Type', 'application/json');
    return h;
  }

  /**
   * 初始化：设置 Klaviyo Company ID 和 List ID
   * @param {string} companyId
   * @param {string} listId
   */
  function init(companyId, listId) {
    _companyId = companyId;
    _listId = listId;
  }

  /**
   * 创建 Klaviyo Profile（用户档案）
   * @param {string} email
   * @returns {Promise}
   */
  function createProfile(email) {
    return window.themeRequest(
      'https://a.klaviyo.com/client/profiles?company_id=' + _companyId,
      {
        method: 'POST',
        headers: klaviyoHeaders(),
        body: JSON.stringify({
          data: { type: 'profile', attributes: { email: email } }
        }),
        redirect: 'follow',
        handleError: false
      }
    );
  }

  /**
   * 创建订阅关系（绑定到指定 List）
   * @param {string} email
   * @returns {Promise}
   */
  function createSubscription(email) {
    return window.themeRequest(
      'https://a.klaviyo.com/client/subscriptions?company_id=' + _companyId,
      {
        method: 'POST',
        headers: klaviyoHeaders(),
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: { data: { type: 'profile', attributes: { email: email } } },
              custom_source: 'API'
            },
            relationships: {
              list: { data: { type: 'list', id: _listId } }
            }
          }
        }),
        redirect: 'follow',
        handleError: false
      }
    );
  }

  /**
   * 校验邮箱格式
   * @param {string} email
   * @returns {boolean}
   */
  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
  }

  window.klaviyoApi = {
    init: init,
    createProfile: createProfile,
    createSubscription: createSubscription,
    isValidEmail: isValidEmail
  };
})();
